import React, { ReactNode } from 'react';
import { TableCell } from '@mui/material';
import { TableCellProps } from '@mui/material/TableCell';

type ResizableTableCellProps = Omit<TableCellProps, 'onResize'> & {
  children: ReactNode;
  width?: number;
  onResize?: (newWidth: number) => void;
};

const MIN_WIDTH = 10;

const ResizableTableCell = ({ children, width = MIN_WIDTH, onResize, ...props }: ResizableTableCellProps) => {
  const startResize = (e: React.MouseEvent) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = width;

    const onMouseMove = (e: MouseEvent) => {
      const deltaX = e.clientX - startX;
      const newWidth = Math.max(MIN_WIDTH, startWidth + deltaX);
      onResize?.(newWidth);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  return (
    <TableCell style={{ width, minWidth: MIN_WIDTH, position: 'relative' }} {...props}>
      <div className="flex items-center h-full">
        <span className="grow overflow-hidden text-ellipsis text-nowrap">{children}</span>
        <div
          className="hover:bg-gray-500 cursor-col-resize h-full absolute right-0 top-0 w-2 z-10"
          onMouseDown={startResize}
        />
      </div>
    </TableCell>
  );
};

export default ResizableTableCell;
